"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.toCamelCase = toCamelCase;
exports.toSnakeCase = toSnakeCase;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _camelCase2 = _interopRequireDefault(require("lodash/camelCase"));
var _snakeCase2 = _interopRequireDefault(require("lodash/snakeCase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var isArray = function isArray(obj) {
  return Array.isArray(obj);
};
var isObject = function isObject(obj) {
  return obj === Object(obj) && !isArray(obj) && typeof obj !== 'function';
};

/**
 * Mostly cribbed from here, but using lodash instead
 * https://matthiashager.com/converting-snake-case-to-camel-case-object-keys-with-javascript
 */
var convert = function convert(obj, func) {
  if (isObject(obj)) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
      var newKey = func(key);
      newObj[newKey] = convert(obj[key], func);
    });
    return newObj;
  }
  if (isArray(obj)) {
    return obj.map(function (element) {
      return convert(element, func);
    });
  }
  return obj;
};

/**
 * Converts an object, say for a API response, with camelCaseKeys to an
 * object with snake_case_keys.
 */
function toSnakeCase(obj) {
  return convert(obj, _snakeCase2.default);
}

/**
 * Converts an object, say for a API request, with snake_case_keys to an
 * object with camelCaseKeys.
 */
function toCamelCase(obj) {
  return convert(obj, _camelCase2.default);
}
var _default = exports.default = {
  toSnakeCase: toSnakeCase,
  toCamelCase: toCamelCase
};